<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.sociograms', 2),
                        href: meta.links.index,
                    },
                    {
                        name: sociogramSurvey.group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <SociogramSurveyShowPage :sociogram-survey="sociogramSurvey" :meta="meta" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SociogramSurveyShowPage from './partials/SociogramSurveyShowPage.vue';

export default {
    components: {
        SociogramSurveyShowPage,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'sociogramSurvey'],
};
</script>
